module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0072_invetory_report_check")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize,
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('title-and-slot', {
    attrs: {
      "title": "棚卸報告確認"
    }
  }), _vm._v(" "), _c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "30px",
      "float": "left"
    }
  }, [_vm._v("　　　　　　会社：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedcompany),
      expression: "selectedcompany"
    }],
    staticClass: "form-control select-box",
    staticStyle: {
      "margin-top": "30px",
      "display": "inline",
      "width": "300px",
      "height": "24px",
      "padding": "0 6px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedcompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.EditableUser == true) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.companylist), function(r) {
    return _c('option', {
      key: r.value,
      domProps: {
        "value": r.value
      }
    }, [_vm._v(_vm._s(r.value))])
  })], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "float": "left"
    }
  }, [_vm._v("棚卸報告年度区分：")]), _vm._v(" "), _c('select', {
    staticClass: "form-control select-box",
    staticStyle: {
      "display": "inline",
      "width": "300px",
      "height": "24px",
      "padding": "0 6px"
    },
    domProps: {
      "value": _vm.selvalues['reporting_period']
    },
    on: {
      "change": function($event) {
        _vm.onSelectPeriod($event.target.value)
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.reportingPeriodList), function(r) {
    return _c('option', {
      key: r.value,
      domProps: {
        "value": r.value
      }
    }, [_vm._v(_vm._s(r.value))])
  })], 2)]), _vm._v(" "), (_vm.EditableUser == true) ? _c('div', [(_vm.withinperiod == false && _vm.admineditable && _vm.viewcaution) ? _c('div', {
    staticClass: "row"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n        報告期間外です\n        ")])], 1) : (_vm.withinperiod && _vm.admineditable == false && _vm.viewcaution) ? _c('div', {
    staticClass: "row"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n        報告がロックされています\n        ")])], 1) : (_vm.withinperiod == false && _vm.admineditable == false && _vm.viewcaution) ? _c('div', {
    staticClass: "row"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n        報告がロックされており期間外です\n        ")])], 1) : _c('div', {
    staticClass: "row"
  })]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('br'), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs",
      "value": _vm.selectedTab
    },
    on: {
      "active": function($event) {
        _vm.onTabChanged($event)
      }
    }
  }, [_c('tab', {
    attrs: {
      "header": "EUC /その他"
    }
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "IT所管システム"
    }
  }), _vm._v(" "), (_vm.InventoryApprovalInquiry > 0) ? _c('tab', {
    attrs: {
      "header": "棚卸申請承認"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.EditableUser == true && _vm.selectedTab != 2) ? _c('div', {}, [_c('br'), _vm._v(" "), _c('report-totals-box', {
    attrs: {
      "tag": "reportTotalsBox"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), (_vm.selectedTab != 2) ? _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('br'), _vm._v(" "), (_vm.rejectmode == true) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RejectReasonText),
      expression: "RejectReasonText"
    }],
    staticClass: "form-control",
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px",
      "margin-right": "15px",
      "height": "100px",
      "width": "500px",
      "resize": "none"
    },
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.RejectReasonText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RejectReasonText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "end",
      "margin-bottom": "10px"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n              ※差戻理由を入力し、入力完了をクリックしてください。(任意)\n              ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.disablePageReject
    },
    on: {
      "click": _vm.onRejectEmbedded
    }
  }, [_vm._v(_vm._s(_vm.RejectSaveText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.rejectcancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")])]) : _vm._e(), _vm._v(" "), (_vm.rejectmode == false) ? _c('div', [(_vm.EditableUser == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.disableUnreportList || _vm.formExportFileDisabled || _vm.checkUserPermission(true, _vm.permissionMode.EXPORT) == false
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]) : _vm._e(), _vm._v(" "), (_vm.EditableUser == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.disableUnreportList
    },
    on: {
      "click": _vm.ShowUnreportList
    }
  }, [_vm._v("報告リスト")]) : _vm._e(), _vm._v(" "), (_vm.EditableUser == true && this.admineditable == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.disablePageReject
    },
    on: {
      "click": _vm.onRejectStart
    }
  }, [_vm._v(_vm._s(_vm.RejectText))]) : _vm._e()]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.EditableUser == true) ? _c('div', [_c('inventory-unreport-list-euc', {
    attrs: {
      "tag": "showinventoryunreportlisteuc"
    },
    on: {
      "done": _vm.onlisteucFile
    }
  }), _vm._v(" "), _c('inventory-unreport-list-it', {
    attrs: {
      "tag": "showinventoryunreportlistit"
    },
    on: {
      "done": _vm.onlistitFile
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirminventorycheckonRejectEmbedded"
    },
    on: {
      "done": _vm.onReject
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirminventorycheckonRejectEmbeddednotification"
    },
    on: {
      "done": _vm.onRejectEnd
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runinventoryreportlistDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b8d4b58","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0072_inventory_report_check.vue
// module id = 1001
// module chunks = 0